module.exports = __webpack_public_path__ + "static/card1-eb65fe1ec2454d26301927779471baf1.png";